import { Box, Button, FormControl, FormHelperText, Stack } from "@mui/material";
import { useState } from "react";

import { ArrayHelper } from "@/common/helpers/array";
import { ApiEnumName } from "@/common/services/enum";
import { GeneralStatusIdentifier } from "@/core/api/generated/v1";

import ApiEnumsAutocomplete from "../../Enum/ApiEnumsAutocomplete";
import AppPopoverActions from "../../Popover/AppPopoverActions";

export interface VehicleStatusScheduleEntryFilters {
  statusIdentifiers?: GeneralStatusIdentifier[];
}

interface Props {
  defaultValue: VehicleStatusScheduleEntryFilters | null;
  onCancel: () => void;
  onSave: (value: VehicleStatusScheduleEntryFilters | null) => void;
}

export function VehicleStatusScheduleEntryFiltersInput({ defaultValue, onCancel, onSave }: Props) {
  const [value, setValue] = useState<VehicleStatusScheduleEntryFilters | null>(defaultValue);

  return (
    <Stack gap={2}>
      <Box>
        <FormControl fullWidth margin='dense'>
          <ApiEnumsAutocomplete
            type={ApiEnumName.GeneralStatusIdentifier}
            onlyEnumValues={[
              GeneralStatusIdentifier.VehicleStatus,
              GeneralStatusIdentifier.AvailabilityStatus,
              GeneralStatusIdentifier.UtilizationStatus,
              GeneralStatusIdentifier.OperabilityStatus,
            ]}
            label='Status types'
            size='small'
            values={value?.statusIdentifiers || []}
            onChange={(newValues) => {
              setValue((prev) => ({
                ...prev,
                statusIdentifiers: ArrayHelper.undefinedIfEmpty(newValues),
              }));
            }}
          />
          <FormHelperText>Leave empty to view all.</FormHelperText>
        </FormControl>
      </Box>

      <AppPopoverActions
        primaryActions={
          <>
            <Button variant='outlined' size='small' color='text' onClick={onCancel}>
              Cancel
            </Button>
            <Button variant='contained' size='small' color='primary' onClick={() => onSave(value)}>
              Save
            </Button>
          </>
        }
        secondaryActions={
          <>
            <Button variant='text' size='small' color='text' onClick={() => setValue(null)}>
              Reset
            </Button>
          </>
        }
      />
    </Stack>
  );
}
